module.exports = __webpack_public_path__ + "static/media/commingSoon.6a5a67e4.gif";